import React from "react";
import { createPortal } from "react-dom";
import "./common.scss";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/popupCloseIcon.svg";

const ThreeActionPopup = ({
  icon,
  content,
  popupClassName = "",
  handleClose,
  firstAction,
  secondAction,
  thirdAction,
  firstActionClassName = "",
  secondActionClassName = "",
  thirdActionClassName = "",
}) => {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="popup-container">
      <div
        className={`popup flex flex-col items-center bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative w-[335px] sm:w-[560px] px-6 py-8 ${popupClassName}`}
      >
        {handleClose && (
          <div className="h-[3%]">
            <CloseIcon
              className="absolute top-3 right-3 cursor-pointer w-[12px] h-[12px]"
              onClick={handleClose}
            />
          </div>
        )}
        <img src={icon} className="w-[40px] h-[40px] mb-4" alt="" />
        <p className="text-[16px] sm:text-[18px] font-[400] font-montserrat text-[#303030] text-center break-words w-full leading-[1.45]">
          {content}
        </p>
        <div className="w-full flex flex-col sm:flex-row justify-center items-stretch gap-3 mt-8">
          <div className={`flex-1 ${firstActionClassName}`}>{firstAction}</div>
          <div className={`flex-1 ${secondActionClassName}`}>{secondAction}</div>
          <div className={`flex-1 ${thirdActionClassName}`}>{thirdAction}</div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ThreeActionPopup;
